import BaseAPI from "api/BaseAPI";

class User extends BaseAPI {
	
	async getUser() {
			let response =  await this.init().get("/account/user");
			return response.data;
	}
	
	async changeActiveCompany(company) {
			let data = {};
			data["company_id"] = null;
			if(company && company.id > 0) {
				data["company_id"] = company.id;
			}
			let response =  await this.init().post("/account/user/setCurrentCompany", data);
			return response.data;
	}	
	
	updateUser(userData) {
		try {
			const params = userData.getData();
			let formData = new FormData();
			for ( var key in params ) {
				if(params[key] !== null) {
					formData.append(key, params[key]);
				}
			}
			
			let image = userData.image;
			if(image && image.file) {
				formData.append("file", image.file);
			}
			
			var t = this.init().post("/account/user", formData, {
				headers: {
					"Content-Type": "multipart/form-data",
			}});
			return t;
		} catch(error) {
			console.error( error );
		}
		return false;
	}
	
}


export default new User();